import { toast } from 'sonner';
import { testsApi } from '@/api/tests';
import { buildWhatsAppUrl } from '@/lib/whatsapp';
import { getSharableTestText } from '@/pages/tests/utils/getTestText';

type ShareAction = 'copy' | 'whatsapp';

type ShareTestLinkParams = {
    patientId: string;
    assignmentId: string;
    action: ShareAction;
};

export const shareTestLink = async ({ patientId, assignmentId, action }: ShareTestLinkParams) => {
    const toastId = toast.loading('Gerando link de acesso...');

    try {
        const data = await testsApi.getAssignmentToken(patientId, assignmentId);
        const token = data?.token;

        if (!token) {
            toast.error('Não foi possível recuperar o token de acesso.');
            return;
        }

        const link = `${window.location.origin}/patients/test/answer?token=${token}`;

        if (action === 'copy') {
            await navigator.clipboard.writeText(link);
            toast.success('Link copiado para a área de transferência!');
            return;
        }

        window.open(buildWhatsAppUrl(getSharableTestText(link)), '_blank');
        toast.success('WhatsApp aberto!');
    } catch (error) {
        console.error(error);
        toast.error('Erro ao buscar o token de acesso.');
    } finally {
        toast.dismiss(toastId);
    }
};
